import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ResourceRequestStatusChip from '~/modules/resourcing/common/components/ResourceRequestStatusChip';
import ResourceRequestResourceInfo from '~/modules/projects/resourcing-plan/ResourceRequestChart/components/ResourceRequestItem/components/ResourceRequestResourceInfo';
import { getResourceRequestStatusStyles } from '~/modules/resourcing/common/util/status-color-util';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1)
  }
}));

const useResourceRequestRowInfoStyle = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0)
  },
  groupsRow: {
    width: theme.spacing(13.5),
    maxWidth: theme.spacing(13.5)
  }
}));

const useStatusChipStyle = makeStyles(theme => ({
  root: {
    ...theme.typography.body2,
    borderRadius: theme.spacing(2),
    maxWidth: theme.spacing(12.5),
    margin: theme.spacing(0.25, 0)
  },
  label: {
    padding: theme.spacing(0, 1.5)
  },
  ...getResourceRequestStatusStyles(theme)
}));

export const ResourceRequestMatchItemInfo = ({
  resourceRequest,
  maxSkillLevel
}) => {
  const { id, requestStatus } = resourceRequest;
  const classes = useStyles();
  const resourceRequestRowInfoClasses = useResourceRequestRowInfoStyle();
  const statusChipClasses = useStatusChipStyle();
  const dataQeId = `${id}_ResourceRequestMatchItemInfo`;

  return (
    <div data-qe-id={dataQeId} className={classes.root}>
      <ResourceRequestResourceInfo
        classes={resourceRequestRowInfoClasses}
        resourceRequest={resourceRequest}
        maxSkillLevel={maxSkillLevel}
      />
      <ResourceRequestStatusChip
        qeIdTag={dataQeId}
        status={requestStatus}
        classes={statusChipClasses}
      />
    </div>
  );
};

ResourceRequestMatchItemInfo.propTypes = {
  resourceRequest: PropTypes.object.isRequired,
  maxSkillLevel: PropTypes.number
};

export default ResourceRequestMatchItemInfo;
